module.exports = __webpack_public_path__ + "img/bookcaseIcon.439670e1.svg";